(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("muze", [], factory);
	else if(typeof exports === 'object')
		exports["muze"] = factory();
	else
		root["muze"] = factory();
})(window, function() {
return 